// Report data — ESG_54 report data store, served by the Sustina API at /api/v1/reporting
// (SQL Server nrgpi_esg_report_data, RDB11), reached through the BFF like every other
// Sustina call (channel "reporting"). dbPayload adds SITE-KEY and puts the session into
// the body. Signed-in global admins only (for now).
//
// ONE store for every reporting value: typed on a topic form, uploaded, or pulled by a
// connector — each with its provenance. Sections are PRE_DRAFT (freely editable) until a
// user sets them to DRAFT; from then on every change needs a coded reason and makes a
// new version, and any version can be made current again.
import { dbPayload } from "../../../../auth/registered/SEC_00_DB_Payload";

const SITE_KEY = process.env.REACT_APP_SITE_KEY;

const call = async (op, body) => {
  let json;
  try {
    json = await dbPayload(`/api/v1/reporting/${op}`, "POST", SITE_KEY, body || {});
  } catch (e) {
    throw new Error(e?.message || "The reporting service cannot be reached.");
  }
  if (!json || !json.success) throw new Error(json?.message || `Reporting ${op} failed.`);
  return json.data;
};

export const fetchReportCodes = () => call("codes");
export const listSections = (companyId) => call("sections/list", { corporateEntityId: Number(companyId) });
export const findSection = (companyId, topicKey, from, to) =>
  call("sections/find", { corporateEntityId: Number(companyId), topicKey, periodFrom: from, periodTo: to });
export const getSection = (sectionId) => call("sections/get", { sectionId });
export const sectionHistory = (sectionId) => call("sections/history", { sectionId });
export const setSectionDraft = (sectionId, note) => call("sections/set-draft", { sectionId, note: note || null });
export const restoreSectionVersion = (sectionId, versionNo, note) => call("sections/restore", { sectionId, versionNo, note: note || null });

/** values = [{ path, value, unit, sourceCode, sourceRef }] */
export const saveSection = ({ companyId, topicKey, pillarCode, from, to, values, reasonCode, reasonNote }) =>
  call("sections/save", {
    corporateEntityId: Number(companyId), topicKey, pillarCode, periodFrom: from, periodTo: to,
    values, reasonCode: reasonCode || null, reasonNote: reasonNote || null,
  });

/**
 * Automated feeds (HR & Workforce, Accounts & Ledger) — several topic sections at once.
 * sections = [{ topicKey, pillarCode, values }]; Draft sections are left untouched.
 */
export const feedSections = (companyId, from, to, sections) =>
  call("sections/save-many", {
    sections: sections.map((s) => ({
      corporateEntityId: Number(companyId), topicKey: s.topicKey, pillarCode: s.pillarCode,
      periodFrom: from, periodTo: to, values: s.values,
    })),
  });

/** Form value → stored text ("" / null = no value). */
export const toStoredText = (v) => {
  if (v === null || v === undefined || v === "") return null;
  if (typeof v === "boolean") return v ? "true" : "false";
  return String(v);
};

/** Stored text → form value, by field type. */
export const fromStoredText = (text, type) => {
  if (text === null || text === undefined) return type === "boolean" ? false : "";
  if (type === "number") return text === "" ? "" : Number(text);
  if (type === "boolean") return text === "true";
  return text;
};
